export const PAGE_STYLE_DARK = 'dark';
export const PAGE_STYLE_DEFAULT = 'default';
export const PAGE_STYLE_LIGHT = 'light';
export const PAGE_TYPE_ACCORDION = 'accordion';
export const PAGE_TYPE_CONTINUOUS = 'continuous';
export const PAGE_TYPE_DROPDOWN = 'dropdown';
export const PAGE_TYPE_TABBED = 'tabbed';
export const TYPE_APP_PAGE = 'appPage';
export const TYPE_ARTICLE = 'article';